import styled from "styled-components";

/* 게임별 키컬러. 띠로 깔지 않고 스크린샷 프레임 그림자에만 쓴다. */
export const BANDS = {
  studentMaker: { key: "#ff9a4d" },
  jobSeeker: { key: "#7cc4f2" },
  yeonae: { key: "#ff5f9e" },
  galaxy: { key: "#1b6e7a" },
};

export const ProductList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProductRow = styled.article`
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
  gap: var(--space-12);
  align-items: center;
  padding: var(--space-16) 0;
  border-top: 2px solid var(--text-primary);

  &:first-child {
    border-top: 0;
    padding-top: 0;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: var(--space-8);
    padding: var(--space-10) 0;

    & > .visual {
      order: -1;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-4);
`;

export const AppIcon = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 14px;
  border: 2px solid var(--text-primary);
  object-fit: cover;
  flex-shrink: 0;
`;

export const Title = styled.h3`
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: var(--font-weight-black);
  letter-spacing: -0.035em;
  line-height: 1.1;
  color: var(--text-primary);
  word-break: keep-all;
`;

export const Meta = styled.p`
  margin-top: var(--space-4);
  font-size: 0.875rem;
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
`;

export const Subtitle = styled.p`
  margin-top: var(--space-2);
  font-size: 1.125rem;
  line-height: 1.6;
  color: var(--text-secondary);
  word-break: keep-all;
  text-wrap: pretty;
`;

export const BigStat = styled.div`
  margin-top: var(--space-8);
`;

export const BigStatValue = styled.div`
  font-size: clamp(2.5rem, 4.5vw, 3.5rem);
  font-weight: var(--font-weight-black);
  letter-spacing: -0.04em;
  line-height: 1;
  color: var(--text-primary);
`;

export const BigStatLabel = styled.div`
  margin-top: var(--space-2);
  font-size: 0.9375rem;
  color: var(--text-secondary);
`;

export const FactList = styled.ul`
  list-style: none;
  margin-top: var(--space-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;

export const FactItem = styled.li`
  font-size: 0.9375rem;
  line-height: 1.6;
  color: var(--text-secondary);
  word-break: keep-all;

  & strong {
    color: var(--text-primary);
    font-weight: var(--font-weight-bold);
  }
`;

export const Status = styled.p`
  display: inline-block;
  margin-top: var(--space-6);
  padding: 0.4rem 0.9rem;
  border: 2px solid var(--text-primary);
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
`;

export const Action = styled.div`
  margin-top: var(--space-8);
`;

/* 스크린샷 스티커 프레임. 그림자 색이 게임의 키컬러다. */
export const Visual = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: var(--radius-lg);
  border: 3px solid var(--text-primary);
  box-shadow: 10px 10px 0 ${({ $band }) => $band.key};
  overflow: hidden;
  background: var(--bg-elevated);

  @media screen and (max-width: 900px) {
    box-shadow: 6px 6px 0 ${({ $band }) => $band.key};
  }
`;

export const Slide = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  transition: opacity 0.9s ease;
`;

export const SaasRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3) var(--space-8);
  padding: var(--space-8) 0 0;
  border-top: 2px solid var(--text-primary);

  & h3 {
    font-size: 1.25rem;
    font-weight: var(--font-weight-extrabold);
    color: var(--text-primary);
  }
  & p {
    margin-top: var(--space-1);
    font-size: 0.9375rem;
    color: var(--text-secondary);
    word-break: keep-all;
  }
`;

export const SaasStatus = styled.span`
  font-size: 0.875rem;
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
  white-space: nowrap;
`;
